import moment from 'moment'
import { dateToDbUtcString } from '@/utils/timeEntry'

const state = {
  currentDateRange: [dateToDbUtcString(moment(new Date()).startOf('day')), dateToDbUtcString(moment(new Date()).endOf('day'))],
  customDateRange: null
}

const mutations = {
  updateCurrentDateRange (state, range) {
    state.currentDateRange = [dateToDbUtcString(moment(range[0]).startOf('day')), dateToDbUtcString(moment(range[1]).endOf('day'))]
  },
  setCustomDateRange (state) {
    state.customDateRange = state.currentDateRange
  },
  applyCustomDateRange (state) {
    if (state.currentDateRange) {
      state.currentDateRange = state.customDateRange
    }
  }
}

const getters = {
  currentDateRange: state => {
    return state.currentDateRange
  },
  customDateRange: state => state.customDateRange
}

export default {
  state,
  mutations,
  getters
}
